/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Expand: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.2927 10.2927C12.6589 9.92662 13.2379 9.90402 13.6306 10.2244L13.7068 10.2927L17.9998 14.5857L22.2927 10.2927L22.3689 10.2244C22.7617 9.90402 23.3407 9.92662 23.7068 10.2927C24.0729 10.6589 24.0955 11.2379 23.7752 11.6306L23.7068 11.7068L18.7068 16.7068C18.5193 16.8943 18.265 16.9998 17.9998 16.9998C17.7677 16.9998 17.5439 16.919 17.366 16.7732L17.2927 16.7068L12.2927 11.7068L12.2244 11.6306C11.904 11.2379 11.9266 10.6589 12.2927 10.2927Z'
      fill='currentColor'
    />
  </React.Fragment>
)
